import { message } from "antd"
import axios from "axios"

export function getBaseApiUrl(): string {
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname.toLowerCase()
    if (host.includes("aiga") || host.includes("ittec.uz")) {
      return "https://restaiga.ittec.uz/api/"
    }
    if (host.includes("erp1") || host.includes("zendig.uz")) {
      return "https://apierp1.zendig.uz/api/"
    }
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }
  return process.env.NODE_ENV === "production"
    ? "https://restaiga.ittec.uz/api/"
    : "http://localhost:5000/api/"
}

export function getSiteUrl(): string {
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname.toLowerCase()
    if (host.includes("aiga") || host.includes("ittec.uz")) {
      return "https://aiga.ittec.uz"
    }
    if (host.includes("erp1") || host.includes("zendig.uz")) {
      return "https://erp1.zendig.uz"
    }
  }
  return process.env.REACT_APP_SITE_URL || ""
}

export function getWsUrl(): string {
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname.toLowerCase()
    if (host.includes("aiga") || host.includes("ittec.uz")) {
      return "wss://restaiga.ittec.uz/"
    }
    if (host.includes("erp1") || host.includes("zendig.uz")) {
      return "wss://apierp1.zendig.uz/"
    }
  }
  return process.env.REACT_APP_WS_URL || "ws://localhost:5000/"
}

export const API_URL = getBaseApiUrl()
export const SITE_URL = getSiteUrl()
export const WS_URL = getWsUrl()
export const MEDIA_URL = SITE_URL + "/media/"

const client = axios.create({ baseURL: API_URL })

export const request = ({ ...options }) => {
  let auth = localStorage.getItem("accessToken")
    ? `Bearer ${localStorage.getItem("accessToken")}`
    : ""
  client.defaults.baseURL = getBaseApiUrl()
  client.defaults.headers.common.Authorization = auth
  client.defaults.headers.common.Accept = "application/json"

  const onSuccess = (response: any) => {
    return response
  }
  const onError = (error: any) => {
    message.error(`${error.message}, ${options.url}`)
    return Promise.reject(error)
  }
  return client(options).then(onSuccess).catch(onError)
}
